/**
 * Application route paths
 * @constant
 */
export const PATHS = {
  // Auth routes
  AUTH: {
    SIGNIN: '/signin',
    SIGNUP: '/signup',
    RESET_PASSWORD: '/reset-password',
  },

  // Main routes
  DASHBOARD: '/',
  TESTS: '/tests',
  TEST_DETAIL: '/tests/:testId/take',

  COMMUNITY: {
    MY_PROFILE: '/community/profile',
    USER_PROFILE: '/community/profile/:userId',
    MEMBERS: '/community/members'
  },

  // Error routes
  ERROR: {
    NOT_FOUND: '/not-found',
  }
};
